export default __webpack_public_path__ + "static/media/miriam.66c46174.jpg";